<template>
  <page-view title="填报">
    <a-card>
      <a-descriptions bordered size="small" :column="{ xxl: 5 }">
        <a-descriptions-item label="项目名称" :span="5">
          <b style="color: #1A5FD0;font-size: 20px">是是是大厦建设工程项目 （440923）</b>
        </a-descriptions-item>
        <a-descriptions-item label="申请人">
          张三
        </a-descriptions-item>
        <a-descriptions-item label="申请时间">
          2025-01-20
        </a-descriptions-item>
        <a-descriptions-item label="处理人">
          管理员
        </a-descriptions-item>
        <a-descriptions-item label="开标时间">
          2025-01-20 09:00
        </a-descriptions-item>
        <a-descriptions-item label="预计时长">
          4小时
        </a-descriptions-item>
        <a-descriptions-item label="用途">
          <a-tag color="blue">项目评审</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="采购方式">
          <a-tag color="blue">公开招标</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="专家咨询电话">
          020-83651133
        </a-descriptions-item>
        <a-descriptions-item label="集合时间">
          2025-01-22 09:00
        </a-descriptions-item>
        <a-descriptions-item label="需携带资料">
          身份证原件
        </a-descriptions-item>
        <a-descriptions-item label="集合地点" :span="5">
          广州市越秀区东风中路389号壬丰商务大厦23层
        </a-descriptions-item>
        <a-descriptions-item label="回避单位" :span="5">
          xxx
        </a-descriptions-item>
        <a-descriptions-item label="回避专家" :span="5">
          xxx
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
    <a-card class="mt-3">
      <p style="text-align: center;font-weight: bold;font-size: 24px;color: #000">需抽取人数 <span style="color: red">8</span> 人</p>
      <div class="cqrs_box">
        <div class="item">
          <div class="title">
            <a-badge>
              <span slot="count" title="当前品类专家人数不足">
                <a-icon type="exclamation-circle" theme="filled" style="color: red;font-weight: 100;font-size: 14px" />
              </span>
              <span>信息安全设备信息安全设备信息安全设备信息安全设备信息安全设备</span>
            </a-badge>
          </div>
          <div class="ry">
            <div class="img">
              <img :src="$_c + 'img/head1.svg'">
            </div>
            <div class="img">
              <img :src="$_c + 'img/head1.svg'">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="title">信息安全设备</div>
          <div class="ry">
            <div class="img">
              <img :src="$_c + 'img/head2.svg'">
            </div>
            <div class="img">
              <img :src="$_c + 'img/head3.svg'">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="title">信息安全设备</div>
          <div class="ry">
            <div class="img">
              <img :src="$_c + 'img/head2.svg'">
            </div>
            <div class="img">
              <img :src="$_c + 'img/head2.svg'">
            </div>
            <div class="img">
              <img :src="$_c + 'img/head2.svg'">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="title">信息安全设备</div>
          <div class="ry">
            <div class="img">
              <img :src="$_c + 'img/head2.svg'">
            </div>
          </div>
        </div>
      </div>

    </a-card>
    <div class="mt-3" style="text-align: center">
      <a-button style="width: 200px" type="primary" size="large">抽取专家</a-button>
    </div>

    <a-card class="mt-3">
      <a-tabs type="card" default-active-key="1" @change="callback">
        <a-tab-pane key="1">
          <div slot="tab">
            <a-badge count="2">
              第1次抽取
            </a-badge>
          </div>

          <table class="cq_table">
            <tr>
              <th>所属品目</th>
              <th>专家名称/联系方式</th>
              <th>抽取时间</th>
              <th>所在地</th>
              <th>专家状态</th>
              <th>短信状态</th>
              <th>语音状态</th>
              <th>操作</th>
            </tr>
            <tr>
              <th rowspan="2">信息安全设备</th>
              <td>
                <a>***</a>、
                <a>184********</a>
              </td>
              <td>2025年01月20日 10:56</td>
              <td>广东省 / 广州市</td>
              <td>
                <a-tag color="green">参加</a-tag>
              </td>
              <td>
                已发送
                <a-tag>再次发送</a-tag>
              </td>
              <td>
                已呼叫
                <a-tag>再次呼叫</a-tag>
              </td>
              <td>
                <a-button type="primary">
                  参加
                </a-button>
              </td>
            </tr>
            <tr>
              <td>
                <a>***</a>、
                <a>184********</a>
              </td>
              <td>2025年01月20日 10:56</td>
              <td>广东省 / 广州市</td>
              <td>
                <a-tag color="red">拒绝</a-tag>
              </td>
              <td>
                未发送
                <a-tag color="#FBA11A">点击发送</a-tag>
              </td>
              <td>
                未发起呼叫
                <a-tag color="#52C291">发起呼叫</a-tag>
              </td>
              <td>
                <a-button type="primary">
                  参加
                </a-button>
              </td>
            </tr>
            <tr>
              <th rowspan="2">信息安全设备</th>
              <td>
                <a>***</a>、
                <a>184********</a>
              </td>
              <td>2025年01月20日 10:56</td>
              <td>广东省 / 广州市</td>
              <td>
                <a-tag>待确认</a-tag>
              </td>
              <td>
                未发送
                <a-tag color="#FBA11A">点击发送</a-tag>
              </td>
              <td>
                未发起呼叫
                <a-tag color="#52C291">发起呼叫</a-tag>
              </td>
              <td>
                <a-button type="primary">
                  参加
                </a-button>
              </td>
            </tr>
            <tr>
              <td>
                <a>***</a>、
                <a>184********</a>
              </td>
              <td>2025年01月20日 10:56</td>
              <td>广东省 / 广州市</td>
              <td>
                <a-tag color="green">参加</a-tag>
              </td>
              <td>
                未发送
                <a-tag color="#FBA11A">点击发送</a-tag>
              </td>
              <td>
                未发起呼叫
                <a-tag color="#52C291">发起呼叫</a-tag>
              </td>
              <td>
                <a-button type="primary">
                  参加
                </a-button>
              </td>
            </tr>
            <tr>
              <th rowspan="3">信息安全设备</th>
              <td>
                <a>***</a>、
                <a>184********</a>
              </td>
              <td>2025年01月20日 10:56</td>
              <td>广东省 / 广州市</td>
              <td>
                <a-tag>待确认</a-tag>
              </td>
              <td>
                未发送
                <a-tag color="#FBA11A">点击发送</a-tag>
              </td>
              <td>
                未发起呼叫
                <a-tag color="#52C291">发起呼叫</a-tag>
              </td>
              <td>
                <a-button type="primary">
                  参加
                </a-button>
              </td>
            </tr>
            <tr>
              <td>
                <a>***</a>、
                <a>184********</a>
              </td>
              <td>2025年01月20日 10:56</td>
              <td>广东省 / 广州市</td>
              <td>
                <a-tag>待确认</a-tag>
              </td>
              <td>
                未发送
                <a-tag color="#FBA11A">点击发送</a-tag>
              </td>
              <td>
                未发起呼叫
                <a-tag color="#52C291">发起呼叫</a-tag>
              </td>
              <td>
                <a-button type="primary">
                  参加
                </a-button>
              </td>
            </tr>
            <tr>
              <td>
                <a>***</a>、
                <a>184********</a>
              </td>
              <td>2025年01月20日 10:56</td>
              <td>广东省 / 广州市</td>
              <td>
                <a-tag>待确认</a-tag>
              </td>
              <td>
                未发送
                <a-tag color="#FBA11A">点击发送</a-tag>
              </td>
              <td>
                未发起呼叫
                <a-tag color="#52C291">发起呼叫</a-tag>
              </td>
              <td>
                <a-button type="primary">
                  参加
                </a-button>
              </td>
            </tr>
            <tr>
              <th>信息安全设备</th>
              <td>
                <a>***</a>、
                <a>184********</a>
              </td>
              <td>2025年01月20日 10:56</td>
              <td>广东省 / 广州市</td>
              <td>
                <a-tag>待确认</a-tag>
              </td>
              <td>
                未发送
                <a-tag color="#FBA11A">点击发送</a-tag>
              </td>
              <td>
                未发起呼叫
                <a-tag color="#52C291">发起呼叫</a-tag>
              </td>
              <td>
                <a-button type="primary">
                  参加
                </a-button>
              </td>
            </tr>
          </table>
        </a-tab-pane>
        <a-tab-pane key="2">
          <div slot="tab">
            <a-badge count="1">
              第2次抽取
            </a-badge>
          </div>
          Content of Tab Pane 2
        </a-tab-pane>
        <a-tab-pane key="3" tab="第3次抽取">
          Content of Tab Pane 3
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </page-view>
</template>
<script>
import { PageView } from '@/layouts'

export default {
  components: {
    PageView,
  },
  data () {
    return {

    }
  },
  methods: {
    callback(key) {
      console.log(key);
    },
  }
}
</script>
<style lang="less" scoped>


/deep/ .ant-descriptions-item-label{
  width: 120px;
}
.cqrs_box{
  display: flex;
  justify-content: center;
  .item{
    text-align: center;
    margin: 0 12px;
    .title{
      background: #f5f5f5;
      padding: 8px;
      margin-bottom: 24px;
      position: relative;
      &::after{
        content: "";
        width: 1px;
        height: 12px;
        background: #e6e6e6;
        position: absolute;
        bottom: -12px;
        margin: auto;
        left: 0;
        right: 0;
      }
    }
    .ry{
      display: flex;
      justify-content: center;
      .img{
        width: 90px;
        height: 118px;
        background: #F2F2F2;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin: 0 8px;
        position: relative;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
        p{
          font-size: 12px;
          margin-top: 10px;
          color: #6e6e6e;
          margin-bottom: -10px;
        }
        i{
          font-size: 40px;
          font-weight: bold;
          color: #1f76ff;
          border: 2px solid rgba(192, 192, 192, 0.32);
          border-radius: 100%;
        }
        &::after{
          content: "";
          width: 1px;
          height: 12px;
          background: #e6e6e6;
          position: absolute;
          top: -12px;
          margin: auto;
          left: 0;
          right: 0;
        }
        &::before{
          content: "";
          width: 100%;
          box-sizing: content-box;
          padding: 0 8px;
          height: 1px;
          background: #e6e6e6;
          position: absolute;
          top: -12px;
          left: 50%;
          margin: auto;
        }
        &:nth-last-child(1)::before{
          display: none;
        }
      }
    }
  }
}
.hx{
  animation: breathe 2s infinite;
}
@keyframes breathe {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}
</style>
